import Mock from 'mockjs'


//import sys_dic_mock from './sys_dic'






//import sys_user_mock from './sys_user'
//Mock.mock(/\/sys_user/, 'get', sys_user_mock.list)
//Mock.mock(/\/sys_user/, 'post', sys_user_mock.create)
//Mock.mock(/\/sys_user/, 'put', sys_user_mock.update)
//Mock.mock(/\/sys_user/, 'delete', sys_user_mock.del)

//登录
//Mock.mock(/\/login/, 'post', loginAPI.loginByUsername)
//Mock.mock(/\/logout/, 'post', loginAPI.logout)
//Mock.mock(/\/userinfo/, 'get', loginAPI.getUserInfo)



//import contract_mock from './contract'
//Mock.mock(/\/contract/, 'get', contract_mock.list)
//Mock.mock(/\/contract/, 'post', contract_mock.create)
//Mock.mock(/\/contract/, 'put', contract_mock.update)
//Mock.mock(/\/contract/, 'delete', contract_mock.del)

//import contract_list_mock from './contract_list'
//Mock.mock(/\/contract_list/, 'get', contract_list_mock.list)
//Mock.mock(/\/contract_list/, 'post', contract_list_mock.create)
//Mock.mock(/\/contract_list/, 'put', contract_list_mock.update)
//Mock.mock(/\/contract_list/, 'delete', contract_list_mock.del)

//import bank_mock from './bank'
//Mock.mock(/\/bank/, 'get', bank_mock.list)
//Mock.mock(/\/bank/, 'post', bank_mock.create)
//Mock.mock(/\/bank/, 'put', bank_mock.update)
//Mock.mock(/\/bank/, 'delete', bank_mock.del)


//import insurer_mock from './insurer'
//Mock.mock(/\/insurer/, 'get', insurer_mock.list)
//Mock.mock(/\/insurer/, 'post', insurer_mock.create)
//Mock.mock(/\/insurer/, 'put', insurer_mock.update)
//Mock.mock(/\/insurer/, 'delete', insurer_mock.del)
// 
export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js